/**
 * Choose button text based on club type
 * @param {Object} chosenClub - Club object
 * @param {boolean} chosenClub.IsStudio - Whether it's a studio
 * @param {boolean} chosenClub.IsStudioRbox - Whether it's an Rbox studio
 * @param {boolean} chosenClub.IsStudioFizikal - Whether it's a Fizikal studio
 * @param {boolean} chosenClub.IsStudioLeap - Whether it's a Leap studio
 * @param {boolean} chosenClub.IsStudioBoostapp - Whether it's a Boostapp studio
 * @param {boolean} chosenClub.IsStudioFeatShare - Whether it's a FeatShare studio
 * @param {boolean} chosenClub.IsVenueClub - Whether it's a venue club
 * @param {boolean} chosenClub.IsClassSchedule - Whether it has class schedule
 * @param {Function} t - Translation function
 * @returns {string} Button text
 */
export const chooseTextForBtn = (chosenClub, t) => {
  const {
    IsStudio: isStudio,
    IsStudioRbox: isRBox,
    IsStudioFizikal: isStudioFizikal,
    IsStudioLeap: isStudioLeap,
    IsStudioBoostapp: isStudioBoostapp,
    IsStudioFeatShare : isStudioFeatShare,
    IsVenueClub: isVenueClub,
    IsClassSchedule: isClassSchedule,
  } = chosenClub || {};

  const isGeneralCondition = isRBox || isStudioFizikal || isStudioLeap || isStudioBoostapp || isStudioFeatShare;

  if ((isStudio || isClassSchedule || isRBox) && isGeneralCondition) {
    return t("CHOOSE_CLASS"); // workoitbooking
  } else if (isStudioFeatShare) {
    return t("CHOOSE_CLASS"); // selectRoomByDate
  } else if (isVenueClub || isStudio || isStudioFizikal || isStudioLeap || isStudioBoostapp) {
    return t("BOOK"); // phoneCoord
  } else {
    return t("ENTER"); // checkin
  }
};

/**
 * Validate email
 * @param {string} email - Email to validate
 * @returns {boolean} True if email is valid, false otherwise
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
